import { init as initApm } from '@elastic/apm-rum';
import { version } from '../../package.json';

const apm = initApm({
  serviceName: 'ubercourse',
  serverUrl:
    'https://3a718692be674444b2f6d358e2ee356a.apm.europe-west2.gcp.elastic-cloud.com:443',
  serviceVersion: version,
  environment: ENV_TYPE,
  active: __AUTHORING__
});

export default apm;
